import { DASHBOARD_ARC_ORDER, type DashboardId } from '@clinspace/shared';
import type { Dashboard, DashboardHost, DashboardOptions } from './Dashboard.ts';
import { DataCleaningDashboard } from './impl/DataCleaning.ts';
import { EnrollmentDashboard } from './impl/Enrollment.ts';
import { LabAbnormalityDashboard } from './impl/LabAbnormality.ts';
import { MissingDataDashboard } from './impl/MissingData.ts';
import { PatientProfilesDashboard } from './impl/PatientProfiles.ts';
import { ProtocolDeviationDashboard } from './impl/ProtocolDeviation.ts';
import { QueryManagementDashboard } from './impl/QueryManagement.ts';
import { RbmDashboard } from './impl/Rbm.ts';
import { SaeReviewDashboard } from './impl/SaeReview.ts';
import { SubjectStatusDashboard } from './impl/SubjectStatus.ts';
import { VisitComplianceDashboard } from './impl/VisitCompliance.ts';

const FACTORIES: Record<
  DashboardId,
  new (host: DashboardHost, options?: DashboardOptions) => Dashboard
> = {
  Enrollment: EnrollmentDashboard,
  SubjectStatus: SubjectStatusDashboard,
  VisitCompliance: VisitComplianceDashboard,
  MissingData: MissingDataDashboard,
  QueryManagement: QueryManagementDashboard,
  DataCleaning: DataCleaningDashboard,
  ProtocolDeviation: ProtocolDeviationDashboard,
  LabAbnormality: LabAbnormalityDashboard,
  SAEReview: SaeReviewDashboard,
  RiskBasedMonitoring: RbmDashboard,
  PatientProfile: PatientProfilesDashboard,
};

/** Creates all eleven dashboards in arc order. */
export function createDashboards(host: DashboardHost): Dashboard[] {
  return DASHBOARD_ARC_ORDER.map((id) => new FACTORIES[id](host));
}

/** One dashboard; `options.wide` draws it that many times wider (the centre screen's 1.5). */
export function createDashboard(
  id: DashboardId,
  host: DashboardHost,
  options?: DashboardOptions,
): Dashboard {
  return new FACTORIES[id](host, options);
}
